import { cloneDeep } from "lodash";
import { formatCamelCaseToSentenceCase, getText, toArray } from "oolib";
import { queryClient } from "../../index";
import { plainTextToLexical } from "@okf/ootils";

export const __GetContentTypeConfigNew = (id) => {
  
  const fromTpl = queryClient.getQueryData(["tpl", id]);
  const SELF_MANAGED_BASE_CONFIGS = queryClient.getQueryData("platformConfigs")?.SELF_MANAGED_BASE_CONFIGS

  if (!fromTpl) return undefined;

  const d = cloneDeep(
    fromTpl
  );

  // Set defaults for listing configuration
  d.listing = {
    ...(d.listing || {}),
    enable: d.listing?.enable ?? true // Default to true if not specified
  };

  // Set defaults for general configuration
  d.general = {
    content: {
      title: d.general?.content?.title || formatCamelCaseToSentenceCase(d.kp_content_type),
      ctaText: d.general?.content?.ctaText,
      listingDesc: d.general?.content?.listingDesc,
      singular: d.general?.content?.singular,
    },
    sharing: {
      enable: SELF_MANAGED_BASE_CONFIGS?.enableSharingTpl ?? d?.general?.sharing?.enable ?? true, // Default to true
      trackShareCount: d?.general?.sharing?.trackShareCount ?? false, // Default to false
    },
    viewsCount: {
      enable: d?.general?.viewsCount?.enable ?? false, // Default to false
    },
    reactions: Object.keys(d?.general?.reactions || {}).reduce((acc, key) => {
      acc[key] = {
        enable: d?.general?.reactions[key]?.enable,
        icon: d?.general?.reactions[key]?.icon
      };
      return acc;
    }, {}),
    comments: {
      enable: d?.general?.comments?.enable ?? true, // Default to true
    },
    settingsUIStyle: d?.general?.settingsUIStyle,
    templateIndex: {
      type: d?.general?.templateIndex?.type,
      enableOnContributeTpl: d?.general?.templateIndex?.enableOnContributeTpl ?? false,
      enableOnPublishedPage: d?.general?.templateIndex?.enableOnPublishedPage ?? false,
    },
    postPblRedirPath: d?.general?.postPblRedirPath,
    hasUpdateType: d?.general?.hasUpdateType,
    segment: d.general?.segment,
    csvExport: {
      enable: d?.general?.csvExport?.enable,
      populateTagsArray: d?.general?.csvExport?.populateTagsArray,
      excludeFields: d?.general?.csvExport?.excludeFields,
      enableUpdateExport: d?.general?.csvExport?.enableUpdateExport,
      fieldsToSortAtEnd: d?.general?.csvExport?.fieldsToSortAtEnd,
      fetchBatches: {
        enable: d?.general?.csvExport?.fetchBatches?.enable,
        batchSize: d?.general?.csvExport?.fetchBatches?.batchSize,
      }
    },
    allowQuickTagCreation: d.general?.allowQuickTagCreation,

  };

  return d;
};

//can pass multiple segments
export const __GetConfigsBySegmentNew = (segment, options = {}) => {
  const fromAllTpls = queryClient.getQueryData("allTpls")?.map((d) => d.kp_content_type) || [];
  return fromAllTpls
    .map((d) => __GetContentTypeConfigNew(d))
    .filter((d) => toArray(segment).includes(d.general.segment));
};

export const __GetAllContentTypeConfig = (options = {}) => {
  const fromAllTpls = queryClient.getQueryData("allTpls")?.map((d) => d.kp_content_type) || [];
  return fromAllTpls
    .map((d) => __GetContentTypeConfigNew(d))
    .filter(d => ['collections', 'publishing'].includes(d?.general?.segment));

};

export const __GetProfileTypeConfig = (profileTypeId) => {
  let allTpls = queryClient.getQueryData('allTpls');
  return allTpls.find(tpl => tpl.kp_content_type === profileTypeId);
};

export const convertToRichText = value => {
  if (!value) return undefined;
  //means its already rich text
  if (value?.blocks) return value;
  //means its unsupported data type
  if (['string', 'number'].indexOf(typeof value) === -1) return undefined;
  //else means its string or number
  return ({ blocks: [{ text: value }], entityMap: {} });
};

export const convertFromRichText = value => getText(value);

export const convertToLexicalText = value => plainTextToLexical(value);

export const getRichTextAsPlainTextLex = ({ value, stitched = [], depthIdx = 0 }) => {
  const children = depthIdx === 0 ? (value?.editorState?.root?.children || []) : value;

  for (const child of children) {
    if (child.children) {
      getRichTextAsPlainTextLex({ value: child.children, stitched, depthIdx: depthIdx + 1 });
    } else {
      stitched.push(child.text || '');
    }
  }
  if (depthIdx === 0) return stitched.join(' ');
};
